import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const InsuredName = (props) => {
  return (
    <FormGroup controlId="insuredName">
      <Col componentClass={ControlLabel} sm={5}>
        {props.required ? 'Insured Name/ Corporate Name *' : 'Insured Name/ Corporate Name'}
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.insuredName} onChange={props.handleChangeInsuredName}
          required={props.required} autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

InsuredName.propTypes = {
  insuredName: PropTypes.string,
  handleChangeInsuredName: PropTypes.func,
  required: PropTypes.bool
};

export default InsuredName;



// WEBPACK FOOTER //
// ./src/app/components/insuredName/InsuredName.js